import CollageStrips from '../../shared/CollageStrips/CollageStrips';
import MainButton from '../../shared/MainButton/MainButton';
import Typography, { FONT_TYPES } from '../../shared/Typography/Typography';

import { WELCOME_COLLAGE } from '../../../../config/collages';

import logo from '../../../../images/quiz/chooseyourdating_logo.svg';
import laurel from '../../../../images/quiz/laurel.png';

import styles from './Welcome.module.scss';

const Welcome = ({ texts, onNext }) => {
  return (
    <div className={styles.wrapper}>
      <div className={styles.gradient} />
      <img src={logo} alt="ChooseYourDating" className={styles.logo} />
      <CollageStrips
        images={WELCOME_COLLAGE}
        rowsCount={4}
        className={styles.collage}
        isAlternating
      />
      <div className={styles.card}>
        <Typography type={FONT_TYPES.brand} htmlTag="p" className={styles.brand} isCenter>
          MatchMaker
        </Typography>
        <Typography
          type={FONT_TYPES.body_regular}
          htmlTag="p"
          className={styles.subtitle}
          isCenter
        >
          {texts.welcome.subtitle}
        </Typography>
        <MainButton onClick={onNext}>{texts.welcome.cta}</MainButton>
        <div className={styles.laurels}>
          {texts.welcome.laurels.map((title) => (
            <div key={title} className={styles.laurelItem}>
              <img src={laurel} alt="" />
              <div className={styles.laurelTexts}>
                <Typography type={FONT_TYPES.mini_bold} htmlTag="p" className={styles.laurelText}>
                  {title}
                </Typography>
                <Typography
                  type={FONT_TYPES.mini_regular}
                  htmlTag="p"
                  className={styles.laurelText}
                >
                  {texts.welcome.ofTheYear}
                </Typography>
              </div>
              <img src={laurel} alt="" className={styles.laurelMirrored} />
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default Welcome;
